import { onEvent } from "./_dom";

function init(context, selector = "[data-checklist-set]") {
	onEvent(context, selector, "click", (e, el) => {
		const select = el.dataset.checklistSet === "1";
		const checkList = el.closest(".v3-checklist");
		if (checkList) {
			e.preventDefault();
			let first;
			checkList.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
				if(checkbox.checked != select) {
					if(!first) {
						// for 1st checkbox we'll note it...
						first = checkbox;
					} else {
						// for [2,N) checkbox we simply change prop
						checkbox.checked = select;
					}
				}
			});
			// ...and "click" on first to notify about change in the checkbox group
			first?.click();
		}
	});
}

export { init };

